import { ConfigType } from "../utils/requestAPI";

type createProposalsDataType = {
  technicianJobId?: string;
  experience?: string;
  numberOfExperience?: number;
  cost?: string;
  pastProject?: string[];
  qualifications?: string;
  pastClients?: string[];
  startingDate?: Date;
  endDate?: Date;
  workApproach?: string;
  riskAssessment?: string;
  designApproach?: string;
  specification?: string;
  notes?: string;
  proposalType?: string;
};

type GetProposalsParamsType = {
  page?: number;
  limit?: number;
  search?: string;
};
type updateProposalStatusType = {
  status: string;
};

const proposalsApi = {
  // Implemented in index of CreateProposal
  createProposals: (data: createProposalsDataType): ConfigType => {
    return {
      url: "/proposals",
      method: "post",
      data: data,
    };
  },

  // Implemented in index of Proposals
  getProposals: (params: GetProposalsParamsType): ConfigType => {
    return {
      url: "/admin-proposals",
      method: "get",
      params,
      config: { store: { action: "set", key: "proposalsList.data" } },
    };
  },
  // Implemented in index of JobProposal
  getProposalById: (id: string): ConfigType => {
    return {
      url: `/admin-proposals/${id}`,
      method: "get",
      config: { store: { action: "set", key: "proposalsListDetails" } },
    };
  },
  getSpecificProposalById: (id: string): ConfigType => {
    return {
      url: `/admin-proposals/specific/${id}`,
      method: "get",
      config: { store: { action: "set", key: "proposalsListDetails" } },
    };
  },
  // Implemented in ProposalForTechnician of ViewProposal
  getIndividualProposalById: (individualId: string): ConfigType => {
    return {
      url: `/proposals/${individualId}`,
      method: "get",
      config: { store: { action: "set", key: "individualProposalsDetails" } },
    };
  },
  // Implemented in ProposalForTechnician of ViewProposal
  updateProposalStatus: (
    id: string,
    updateId: string,
    data: updateProposalStatusType
  ): ConfigType => {
    return {
      url: `/proposals/update-proposal-status/${id}/${updateId}`,
      method: "patch",
      data: data,
    };
  },

  getAcceptedProposals: (params: GetProposalsParamsType): ConfigType => {
    return {
      url: "/technician-jobs/accepted/proposal-job",
      method: "get",
      params,
      config: { store: { action: "set", key: "acceptedProposals.data" } },
    };
  },
  getAcceptedProposalsDetails: (id: string): ConfigType => {
    return {
      url: `/technician-jobs/accepted/${id}`,
      method: "get",

      config: { store: { action: "set", key: "acceptedProposalsDetails" } },
    };
  },

  getProposalByJobId: (id: string): ConfigType => {
    return {
      url: `/proposals/job/${id}`,
      method: "get",

      config: { store: { action: "set", key: "ProposalsJob" } },
    };
  },

  getTechnicianAllProposals: (params: GetProposalsParamsType): ConfigType => {
    return {
      url: "/proposals/technician",
      method: "get",
      params,
      config: { store: { action: "set", key: "technicianAllProposals.data" } },
    };
  },

  getTechnicianAllProposalById: (id: string): ConfigType => {
    return {
      url: `/proposals/${id}`,
      method: "get",

      config: { store: { action: "set", key: "technicianProposalDetails" } },
    };
  },
};

export default proposalsApi;
